// extracted by mini-css-extract-plugin
module.exports = {"row":"Table_row__8eEDm"};